export const barometroCompleto = [
  {
    "id": "mbfdbqrnph9tfndsmbfg9i3subpr59cg",
    "nombreDeLaEmpresa": "Agzulasa cia ltda",
    "nombreDeQuienResponde": "Lissbeth",
    "productoQueExporta": "Banano",
    "enCasoDeQueEligioOtrosMencioneElProductoQueExporta": null,
    "destinoPrincipalDeExportaciones": "Asia Central",
    "contactoCorreoElectronico": "mubilla@zulay.com",
    "comoCalificaLaDisponibilidadDeContenedoresRefrigeradosOEstandarSegunSuNecesidad": 2,
    "comoCalificaElEstadoDeEstosContenedoresRefrigeradosOEstandarRespectoDelMesAnterior": 3,
    "queTanFacilFueReservarEspaciosConLasNavierasConLasQueTrabaja": 3,
    "queEstrategiasHaImplementadoParaSolucionarlo": null,
    "enComparacionAlUltimoTrimestreDel2024T1ComoHanVariadoLosPreciosDeLosServiciosOfrecidosPorLasNavierasDuranteEsteTrimestre": "Ha incrementado",
    "haPodidoPercibirCambiosEnSuRentabilidadDebidoALasVariacionesEnElPrecioDelFlete": "Se han mantenido",
    "consideraQueLasTarifasOfrecidasPorLasNavierasSonJustasEnComparacionConElVolumenDeCargaQueManeja": 2,
    "haEnfrentadoCostosAdicionalesInesperadosEnLosUltimosMeses": "Si",
    "enCasoDeQueLaRespuestaAnteriorSeaSiEstosCostosAdicionalesEstanDebidamenteJustificados": "Si",
    "consideraQueLosServiciosOfrecidosPorLasNavierasSonCompetitivosEnRelacionConLosDeOtrosPaisesDeLaRegion": "No",
    "haEvaluadoAlternativasDeTransporteDebidoALosCostosActualesDeLasNavieras": "Si",
    "cualesAlternativasDeTransporteHaExplorado": "Tener un respaldo con navífico y traspasados de navieras como alternativa en caso de traspasos.",
    "queTanTransparenteConsideraQueEsLaEstructuraDeCostosPresentadaPorLasNavieras": 3,
    "enGeneralComoCalificariaLaRelacionCostoBeneficioDeLosServiciosQueRecibeDeLasNavieras": 3,
    "comoCalificaLaClaridadDeLaInformacionProporcionadaPorLasNavierasSobreItinerariosYHorarios": 3,
    "haExperimentadoDificultadesDebidoACambiosDeUltimoMomentoEnLosItinerarios": "Si",
    "enCasoDeSiConQueFrecuenciaHanOcurridoEstosCambios": "Ocasionalmente",
    "comoCalificariaLaComunicacionDeLasNavierasAnteEventosImprevistosDemorasODesvios": 3,
    "haTenidoProblemasParaObtenerInformacionActualizadaSobreLaUbicacionDeSusContenedoresDuranteElTransito": "Si",
    "queTanAccesiblesSonLasNavierasCuandoNecesitaResolverDudasOProblemasRelacionadosConLosEnvios": 3,
    "enGeneralComoCalificariaLaCalidadDeLaComunicacionConLasNavierasConLasQueOpera": 3,
    "haRecibidoIncumplimientosDeServiciosPorParteDeAlgunaNaviera": "Si",
    "enCasoDeSiQueTipoDeIncumplimientosHaExperimentado": "Retrasos",
    "haPresentadoQuejasFormalesPorAlgunoDeEstosIncumplimientos": "No",
    "enCasoDeSiConsideraQueLaRespuestaDeLaNavieraHaSidoAdecuada": null,
    "consideraQueLasNavierasConLasQueTrabajaCumplenLosCompromisosEstablecidosEnLosContratosDeServicio": 3,
    "queTanFlexibleConsideraQueEsLaNavieraParaNegociarTerminosEnCasosExcepcionalesPorEjemploRetrasosPorFuerzaMayor": 3,
    "enGeneralComoEvaluariaElNivelDeCumplimientoDeLasNavierasConLasQueTrabaja": 3,
    "haEnfrentadoDificultadesEnLosProcesosDeInspeccionYAduanaQueHayanGeneradoRetrasosEnSusOperaciones": "Si",
    "enCasoDeSiQueTipoDeDificultadesHaExperimentado": "Retrasos",
    "consideraQueLosProcedimientosAduanerosSonClaramentePredeciblesYOConsistentes": 3,
    "comoCalificariaElManejoDeLaMercanciaDuranteLasInspeccionesAduanerasEnTerminosDeCuidadoYPrevencionDeDanos": 3,
    "haExperimentadoDanosEnSuCargaDebidoAUnaInspeccionInadecuada": "Sí",
    "haTenidoProblemasConSusClientesDebidoAlEstadoEnElQueLlegaLaMercanciaDespuesDeLasInspecciones": "Sí",
    "consideraQueElPersonalEncargadoDeLasInspeccionesEstaCapacitadoParaManejarSuProductoSinComprometerSuCalidad": 3,
    "cualEsElPrincipalPuertoEnElQueOpera": "Do world",
    "comoEvaluaLaCapacidadOperativaDeLosPuertosEnLosQueOpera": 4,
    "haExperimentadoCongestionEnLosPuertosEnLosUltimosMeses": "No",
    "losAccesosYViasDeComunicacionHaciaLosPuertosFacilitanElTransporteDeSuCarga": 3,
    "consideraQueLaInfraestructuraActualDeLosPuertosEsSuficienteParaLaDemandaExportadoraDeSuSector": "No",
    "responseType": "completed",
    "startDateUtc": "2025-07-31 01:36:13",
    "stageDateUtc": null,
    "submitDateUtc": "2025-07-31 01:47:21",
    "networkId": "ff0b845434",
    "tags": null,
    "ending": "Thanks for completing this typeform\nNow *create your own* — it's free, easy, & beautiful"
  },
  {
    "id": "l0rpezuytczsxrat80whd9l0rpezuke0",
    "nombreDeLaEmpresa": "Sabrostar Fruit Company",
    "nombreDeQuienResponde": "Angel Punin Borja",
    "productoQueExporta": "Banano",
    "enCasoDeQueEligioOtrosMencioneElProductoQueExporta": null,
    "destinoPrincipalDeExportaciones": "Cono Sur",
    "contactoCorreoElectronico": "apunin@sabrostar.com",
    "comoCalificaLaDisponibilidadDeContenedoresRefrigeradosOEstandarSegunSuNecesidad": 3,
    "comoCalificaElEstadoDeEstosContenedoresRefrigeradosOEstandarRespectoDelMesAnterior": 4,
    "queTanFacilFueReservarEspaciosConLasNavierasConLasQueTrabaja": 4,
    "queEstrategiasHaImplementadoParaSolucionarlo": "Buscar soporte de parte del personal de reservas y/o vendedores de servicio de la línea naviera para obtener el espacio.",
    "enComparacionAlUltimoTrimestreDel2024T1ComoHanVariadoLosPreciosDeLosServiciosOfrecidosPorLasNavierasDuranteEsteTrimestre": "Se han mantenido",
    "haPodidoPercibirCambiosEnSuRentabilidadDebidoALasVariacionesEnElPrecioDelFlete": "Se han mantenido",
    "consideraQueLasTarifasOfrecidasPorLasNavierasSonJustasEnComparacionConElVolumenDeCargaQueManeja": 3,
    "haEnfrentadoCostosAdicionalesInesperadosEnLosUltimosMeses": "No",
    "enCasoDeQueLaRespuestaAnteriorSeaSiEstosCostosAdicionalesEstanDebidamenteJustificados": null,
    "consideraQueLosServiciosOfrecidosPorLasNavierasSonCompetitivosEnRelacionConLosDeOtrosPaisesDeLaRegion": "Si",
    "haEvaluadoAlternativasDeTransporteDebidoALosCostosActualesDeLasNavieras": "No",
    "cualesAlternativasDeTransporteHaExplorado": null,
    "queTanTransparenteConsideraQueEsLaEstructuraDeCostosPresentadaPorLasNavieras": 4,
    "enGeneralComoCalificariaLaRelacionCostoBeneficioDeLosServiciosQueRecibeDeLasNavieras": 4,
    "comoCalificaLaClaridadDeLaInformacionProporcionadaPorLasNavierasSobreItinerariosYHorarios": 4,
    "haExperimentadoDificultadesDebidoACambiosDeUltimoMomentoEnLosItinerarios": "Si",
    "enCasoDeSiConQueFrecuenciaHanOcurridoEstosCambios": "Ocasionalmente",
    "comoCalificariaLaComunicacionDeLasNavierasAnteEventosImprevistosDemorasODesvios": 4,
    "haTenidoProblemasParaObtenerInformacionActualizadaSobreLaUbicacionDeSusContenedoresDuranteElTransito": "No",
    "queTanAccesiblesSonLasNavierasCuandoNecesitaResolverDudasOProblemasRelacionadosConLosEnvios": 4,
    "enGeneralComoCalificariaLaCalidadDeLaComunicacionConLasNavierasConLasQueOpera": 4,
    "haRecibidoIncumplimientosDeServiciosPorParteDeAlgunaNaviera": "Si",
    "enCasoDeSiQueTipoDeIncumplimientosHaExperimentado": "Incumplimiento de itinerario.",
    "haPresentadoQuejasFormalesPorAlgunoDeEstosIncumplimientos": "Si",
    "enCasoDeSiConsideraQueLaRespuestaDeLaNavieraHaSidoAdecuada": "Si",
    "consideraQueLasNavierasConLasQueTrabajaCumplenLosCompromisosEstablecidosEnLosContratosDeServicio": 4,
    "queTanFlexibleConsideraQueEsLaNavieraParaNegociarTerminosEnCasosExcepcionalesPorEjemploRetrasosPorFuerzaMayor": 3,
    "enGeneralComoEvaluariaElNivelDeCumplimientoDeLasNavierasConLasQueTrabaja": 4,
    "haEnfrentadoDificultadesEnLosProcesosDeInspeccionYAduanaQueHayanGeneradoRetrasosEnSusOperaciones": "Si",
    "enCasoDeSiQueTipoDeDificultadesHaExperimentado": "Retraso en el proceso.",
    "consideraQueLosProcedimientosAduanerosSonClaramentePredeciblesYOConsistentes": 3,
    "comoCalificariaElManejoDeLaMercanciaDuranteLasInspeccionesAduanerasEnTerminosDeCuidadoYPrevencionDeDanos": 4,
    "haExperimentadoDanosEnSuCargaDebidoAUnaInspeccionInadecuada": "No",
    "haTenidoProblemasConSusClientesDebidoAlEstadoEnElQueLlegaLaMercanciaDespuesDeLasInspecciones": "No",
    "consideraQueElPersonalEncargadoDeLasInspeccionesEstaCapacitadoParaManejarSuProductoSinComprometerSuCalidad": 4,
    "cualEsElPrincipalPuertoEnElQueOpera": "Puerto de Guayaquil",
    "comoEvaluaLaCapacidadOperativaDeLosPuertosEnLosQueOpera": 4,
    "haExperimentadoCongestionEnLosPuertosEnLosUltimosMeses": "Si",
    "losAccesosYViasDeComunicacionHaciaLosPuertosFacilitanElTransporteDeSuCarga": 4,
    "consideraQueLaInfraestructuraActualDeLosPuertosEsSuficienteParaLaDemandaExportadoraDeSuSector": "Si",
    "responseType": "completed",
    "startDateUtc": "2025-07-30 11:58:57",
    "stageDateUtc": null,
    "submitDateUtc": "2025-07-30 12:06:14",
    "networkId": "4c0b9d0259",
    "tags": null,
    "ending": "Thanks for completing this typeform\nNow *create your own* — it's free, easy, & beautiful"
  },
  {
    "id": "hy1jqvqx77e5c0id4vn2jamhy1jqvn6y",
    "nombreDeLaEmpresa": "Indurama",
    "nombreDeQuienResponde": "Maria Jose Yanez",
    "productoQueExporta": "Otros",
    "enCasoDeQueEligioOtrosMencioneElProductoQueExporta": "Electrodomesticos",
    "destinoPrincipalDeExportaciones": "Centroamerica",
    "contactoCorreoElectronico": "myanez@indurama.com",
    "comoCalificaLaDisponibilidadDeContenedoresRefrigeradosOEstandarSegunSuNecesidad": 4,
    "comoCalificaElEstadoDeEstosContenedoresRefrigeradosOEstandarRespectoDelMesAnterior": 3,
    "queTanFacilFueReservarEspaciosConLasNavierasConLasQueTrabaja": 3,
    "queEstrategiasHaImplementadoParaSolucionarlo": "Planificacion adecuada de la demanda.",
    "enComparacionAlUltimoTrimestreDel2024T1ComoHanVariadoLosPreciosDeLosServiciosOfrecidosPorLasNavierasDuranteEsteTrimestre": "Ha incrementado",
    "haPodidoPercibirCambiosEnSuRentabilidadDebidoALasVariacionesEnElPrecioDelFlete": "Se han reducido",
    "consideraQueLasTarifasOfrecidasPorLasNavierasSonJustasEnComparacionConElVolumenDeCargaQueManeja": 2,
    "haEnfrentadoCostosAdicionalesInesperadosEnLosUltimosMeses": "Si",
    "enCasoDeQueLaRespuestaAnteriorSeaSiEstosCostosAdicionalesEstanDebidamenteJustificados": "No",
    "consideraQueLosServiciosOfrecidosPorLasNavierasSonCompetitivosEnRelacionConLosDeOtrosPaisesDeLaRegion": "No",
    "haEvaluadoAlternativasDeTransporteDebidoALosCostosActualesDeLasNavieras": "Si",
    "cualesAlternativasDeTransporteHaExplorado": "Otros proveedores logísticos.",
    "queTanTransparenteConsideraQueEsLaEstructuraDeCostosPresentadaPorLasNavieras": 2,
    "enGeneralComoCalificariaLaRelacionCostoBeneficioDeLosServiciosQueRecibeDeLasNavieras": 2,
    "comoCalificaLaClaridadDeLaInformacionProporcionadaPorLasNavierasSobreItinerariosYHorarios": 3,
    "haExperimentadoDificultadesDebidoACambiosDeUltimoMomentoEnLosItinerarios": "Si",
    "enCasoDeSiConQueFrecuenciaHanOcurridoEstosCambios": "Frecuentemente",
    "comoCalificariaLaComunicacionDeLasNavierasAnteEventosImprevistosDemorasODesvios": 2,
    "haTenidoProblemasParaObtenerInformacionActualizadaSobreLaUbicacionDeSusContenedoresDuranteElTransito": "Si",
    "queTanAccesiblesSonLasNavierasCuandoNecesitaResolverDudasOProblemasRelacionadosConLosEnvios": 2,
    "enGeneralComoCalificariaLaCalidadDeLaComunicacionConLasNavierasConLasQueOpera": 2,
    "haRecibidoIncumplimientosDeServiciosPorParteDeAlgunaNaviera": "Si",
    "enCasoDeSiQueTipoDeIncumplimientosHaExperimentado": "Cancelaciones de servicios.",
    "haPresentadoQuejasFormalesPorAlgunoDeEstosIncumplimientos": "Si",
    "enCasoDeSiConsideraQueLaRespuestaDeLaNavieraHaSidoAdecuada": "No",
    "consideraQueLasNavierasConLasQueTrabajaCumplenLosCompromisosEstablecidosEnLosContratosDeServicio": 2,
    "queTanFlexibleConsideraQueEsLaNavieraParaNegociarTerminosEnCasosExcepcionalesPorEjemploRetrasosPorFuerzaMayor": 2,
    "enGeneralComoEvaluariaElNivelDeCumplimientoDeLasNavierasConLasQueTrabaja": 2,
    "haEnfrentadoDificultadesEnLosProcesosDeInspeccionYAduanaQueHayanGeneradoRetrasosEnSusOperaciones": "Si",
    "enCasoDeSiQueTipoDeDificultadesHaExperimentado": "Demoras en inspecciones.",
    "consideraQueLosProcedimientosAduanerosSonClaramentePredeciblesYOConsistentes": 2,
    "comoCalificariaElManejoDeLaMercanciaDuranteLasInspeccionesAduanerasEnTerminosDeCuidadoYPrevencionDeDanos": 3,
    "haExperimentadoDanosEnSuCargaDebidoAUnaInspeccionInadecuada": "No",
    "haTenidoProblemasConSusClientesDebidoAlEstadoEnElQueLlegaLaMercanciaDespuesDeLasInspecciones": "No",
    "consideraQueElPersonalEncargadoDeLasInspeccionesEstaCapacitadoParaManejarSuProductoSinComprometerSuCalidad": 2,
    "cualEsElPrincipalPuertoEnElQueOpera": "Puerto de Guayaquil",
    "comoEvaluaLaCapacidadOperativaDeLosPuertosEnLosQueOpera": 3,
    "haExperimentadoCongestionEnLosPuertosEnLosUltimosMeses": "Si",
    "losAccesosYViasDeComunicacionHaciaLosPuertosFacilitanElTransporteDeSuCarga": 3,
    "consideraQueLaInfraestructuraActualDeLosPuertosEsSuficienteParaLaDemandaExportadoraDeSuSector": "No",
    "responseType": "completed",
    "startDateUtc": "2025-07-29 00:07:46",
    "stageDateUtc": null,
    "submitDateUtc": "2025-07-29 00:11:52",
    "networkId": "6811447b27",
    "tags": null,
    "ending": "Thanks for completing this typeform\nNow *create your own* — it's free, easy, & beautiful"
  },
  {
    "id": "zrxwqv76fp8wc9hfp3zrxwqftl37nvr7",
    "nombreDeLaEmpresa": "Freskbana S.A.",
    "nombreDeQuienResponde": "Maria Luisa Chica",
    "productoQueExporta": "Banano",
    "enCasoDeQueEligioOtrosMencioneElProductoQueExporta": null,
    "destinoPrincipalDeExportaciones": "Europa",
    "contactoCorreoElectronico": "mchica@freskbana.com",
    "comoCalificaLaDisponibilidadDeContenedoresRefrigeradosOEstandarSegunSuNecesidad": 4,
    "comoCalificaElEstadoDeEstosContenedoresRefrigeradosOEstandarRespectoDelMesAnterior": 4,
    "queTanFacilFueReservarEspaciosConLasNavierasConLasQueTrabaja": 4,
    "queEstrategiasHaImplementadoParaSolucionarlo": "Trabajo anticipado en reservas.",
    "enComparacionAlUltimoTrimestreDel2024T1ComoHanVariadoLosPreciosDeLosServiciosOfrecidosPorLasNavierasDuranteEsteTrimestre": "Se han mantenido",
    "haPodidoPercibirCambiosEnSuRentabilidadDebidoALasVariacionesEnElPrecioDelFlete": "Se han mantenido",
    "consideraQueLasTarifasOfrecidasPorLasNavierasSonJustasEnComparacionConElVolumenDeCargaQueManeja": 3,
    "haEnfrentadoCostosAdicionalesInesperadosEnLosUltimosMeses": "No",
    "enCasoDeQueLaRespuestaAnteriorSeaSiEstosCostosAdicionalesEstanDebidamenteJustificados": null,
    "consideraQueLosServiciosOfrecidosPorLasNavierasSonCompetitivosEnRelacionConLosDeOtrosPaisesDeLaRegion": "Si",
    "haEvaluadoAlternativasDeTransporteDebidoALosCostosActualesDeLasNavieras": "No",
    "cualesAlternativasDeTransporteHaExplorado": null,
    "queTanTransparenteConsideraQueEsLaEstructuraDeCostosPresentadaPorLasNavieras": 4,
    "enGeneralComoCalificariaLaRelacionCostoBeneficioDeLosServiciosQueRecibeDeLasNavieras": 4,
    "comoCalificaLaClaridadDeLaInformacionProporcionadaPorLasNavierasSobreItinerariosYHorarios": 4,
    "haExperimentadoDificultadesDebidoACambiosDeUltimoMomentoEnLosItinerarios": "No",
    "enCasoDeSiConQueFrecuenciaHanOcurridoEstosCambios": null,
    "comoCalificariaLaComunicacionDeLasNavierasAnteEventosImprevistosDemorasODesvios": 4,
    "haTenidoProblemasParaObtenerInformacionActualizadaSobreLaUbicacionDeSusContenedoresDuranteElTransito": "No",
    "queTanAccesiblesSonLasNavierasCuandoNecesitaResolverDudasOProblemasRelacionadosConLosEnvios": 4,
    "enGeneralComoCalificariaLaCalidadDeLaComunicacionConLasNavierasConLasQueOpera": 4,
    "haRecibidoIncumplimientosDeServiciosPorParteDeAlgunaNaviera": "No",
    "enCasoDeSiQueTipoDeIncumplimientosHaExperimentado": null,
    "haPresentadoQuejasFormalesPorAlgunoDeEstosIncumplimientos": null,
    "enCasoDeSiConsideraQueLaRespuestaDeLaNavieraHaSidoAdecuada": null,
    "consideraQueLasNavierasConLasQueTrabajaCumplenLosCompromisosEstablecidosEnLosContratosDeServicio": 4,
    "queTanFlexibleConsideraQueEsLaNavieraParaNegociarTerminosEnCasosExcepcionalesPorEjemploRetrasosPorFuerzaMayor": 3,
    "enGeneralComoEvaluariaElNivelDeCumplimientoDeLasNavierasConLasQueTrabaja": 4,
    "haEnfrentadoDificultadesEnLosProcesosDeInspeccionYAduanaQueHayanGeneradoRetrasosEnSusOperaciones": "No",
    "enCasoDeSiQueTipoDeDificultadesHaExperimentado": null,
    "consideraQueLosProcedimientosAduanerosSonClaramentePredeciblesYOConsistentes": 4,
    "comoCalificariaElManejoDeLaMercanciaDuranteLasInspeccionesAduanerasEnTerminosDeCuidadoYPrevencionDeDanos": 4,
    "haExperimentadoDanosEnSuCargaDebidoAUnaInspeccionInadecuada": "No",
    "haTenidoProblemasConSusClientesDebidoAlEstadoEnElQueLlegaLaMercanciaDespuesDeLasInspecciones": "No",
    "consideraQueElPersonalEncargadoDeLasInspeccionesEstaCapacitadoParaManejarSuProductoSinComprometerSuCalidad": 4,
    "cualEsElPrincipalPuertoEnElQueOpera": "Puerto de Guayaquil",
    "comoEvaluaLaCapacidadOperativaDeLosPuertosEnLosQueOpera": 4,
    "haExperimentadoCongestionEnLosPuertosEnLosUltimosMeses": "Si",
    "losAccesosYViasDeComunicacionHaciaLosPuertosFacilitanElTransporteDeSuCarga": 4,
    "consideraQueLaInfraestructuraActualDeLosPuertosEsSuficienteParaLaDemandaExportadoraDeSuSector": "Si",
    "responseType": "completed",
    "startDateUtc": "2025-07-28 23:11:34",
    "stageDateUtc": null,
    "submitDateUtc": "2025-07-28 23:19:06",
    "networkId": "d1431a7280",
    "tags": null,
    "ending": "Thanks for completing this typeform\nNow *create your own* — it's free, easy, & beautiful"
  },
  {
    "id": "0z400g8sop94j1hps0z400885pup8ekn",
    "nombreDeLaEmpresa": "REFIN S.A.",
    "nombreDeQuienResponde": "Bernardo Malo",
    "productoQueExporta": "Mango",
    "enCasoDeQueEligioOtrosMencioneElProductoQueExporta": null,
    "destinoPrincipalDeExportaciones": "Estados Unidos",
    "contactoCorreoElectronico": "bmalo@refin.com",
    "comoCalificaLaDisponibilidadDeContenedoresRefrigeradosOEstandarSegunSuNecesidad": 3,
    "comoCalificaElEstadoDeEstosContenedoresRefrigeradosOEstandarRespectoDelMesAnterior": 3,
    "queTanFacilFueReservarEspaciosConLasNavierasConLasQueTrabaja": 5,
    "queEstrategiasHaImplementadoParaSolucionarlo": "Uso de reservas anticipadas.",
    "enComparacionAlUltimoTrimestreDel2024T1ComoHanVariadoLosPreciosDeLosServiciosOfrecidosPorLasNavierasDuranteEsteTrimestre": "Se han mantenido",
    "haPodidoPercibirCambiosEnSuRentabilidadDebidoALasVariacionesEnElPrecioDelFlete": "Se han mantenido",
    "consideraQueLasTarifasOfrecidasPorLasNavierasSonJustasEnComparacionConElVolumenDeCargaQueManeja": 3,
    "haEnfrentadoCostosAdicionalesInesperadosEnLosUltimosMeses": "No",
    "enCasoDeQueLaRespuestaAnteriorSeaSiEstosCostosAdicionalesEstanDebidamenteJustificados": null,
    "consideraQueLosServiciosOfrecidosPorLasNavierasSonCompetitivosEnRelacionConLosDeOtrosPaisesDeLaRegion": "Si",
    "haEvaluadoAlternativasDeTransporteDebidoALosCostosActualesDeLasNavieras": "No",
    "cualesAlternativasDeTransporteHaExplorado": null,
    "queTanTransparenteConsideraQueEsLaEstructuraDeCostosPresentadaPorLasNavieras": 4,
    "enGeneralComoCalificariaLaRelacionCostoBeneficioDeLosServiciosQueRecibeDeLasNavieras": 4,
    "comoCalificaLaClaridadDeLaInformacionProporcionadaPorLasNavierasSobreItinerariosYHorarios": 4,
    "haExperimentadoDificultadesDebidoACambiosDeUltimoMomentoEnLosItinerarios": "No",
    "enCasoDeSiConQueFrecuenciaHanOcurridoEstosCambios": null,
    "comoCalificariaLaComunicacionDeLasNavierasAnteEventosImprevistosDemorasODesvios": 4,
    "haTenidoProblemasParaObtenerInformacionActualizadaSobreLaUbicacionDeSusContenedoresDuranteElTransito": "No",
    "queTanAccesiblesSonLasNavierasCuandoNecesitaResolverDudasOProblemasRelacionadosConLosEnvios": 4,
    "enGeneralComoCalificariaLaCalidadDeLaComunicacionConLasNavierasConLasQueOpera": 4,
    "haRecibidoIncumplimientosDeServiciosPorParteDeAlgunaNaviera": "No",
    "enCasoDeSiQueTipoDeIncumplimientosHaExperimentado": null,
    "haPresentadoQuejasFormalesPorAlgunoDeEstosIncumplimientos": null,
    "enCasoDeSiConsideraQueLaRespuestaDeLaNavieraHaSidoAdecuada": null,
    "consideraQueLasNavierasConLasQueTrabajaCumplenLosCompromisosEstablecidosEnLosContratosDeServicio": 4,
    "queTanFlexibleConsideraQueEsLaNavieraParaNegociarTerminosEnCasosExcepcionalesPorEjemploRetrasosPorFuerzaMayor": 3,
    "enGeneralComoEvaluariaElNivelDeCumplimientoDeLasNavierasConLasQueTrabaja": 4,
    "haEnfrentadoDificultadesEnLosProcesosDeInspeccionYAduanaQueHayanGeneradoRetrasosEnSusOperaciones": "No",
    "enCasoDeSiQueTipoDeDificultadesHaExperimentado": null,
    "consideraQueLosProcedimientosAduanerosSonClaramentePredeciblesYOConsistentes": 4,
    "comoCalificariaElManejoDeLaMercanciaDuranteLasInspeccionesAduanerasEnTerminosDeCuidadoYPrevencionDeDanos": 4,
    "haExperimentadoDanosEnSuCargaDebidoAUnaInspeccionInadecuada": "No",
    "haTenidoProblemasConSusClientesDebidoAlEstadoEnElQueLlegaLaMercanciaDespuesDeLasInspecciones": "No",
    "consideraQueElPersonalEncargadoDeLasInspeccionesEstaCapacitadoParaManejarSuProductoSinComprometerSuCalidad": 4,
    "cualEsElPrincipalPuertoEnElQueOpera": "Puerto de Guayaquil",
    "comoEvaluaLaCapacidadOperativaDeLosPuertosEnLosQueOpera": 4,
    "haExperimentadoCongestionEnLosPuertosEnLosUltimosMeses": "No",
    "losAccesosYViasDeComunicacionHaciaLosPuertosFacilitanElTransporteDeSuCarga": 4,
    "consideraQueLaInfraestructuraActualDeLosPuertosEsSuficienteParaLaDemandaExportadoraDeSuSector": "Si",
    "responseType": "completed",
    "startDateUtc": "2025-07-28 22:33:10",
    "stageDateUtc": null,
    "submitDateUtc": "2025-07-28 22:37:33",
    "networkId": "de10d62c46",
    "tags": null,
    "ending": "Thanks for completing this typeform\nNow *create your own* — it's free, easy, & beautiful"
  },
  {
    "id": "x1d5f4w1yqfs5tx4u6x1d5f4ksq3r6gm",
    "nombreDeLaEmpresa": "Galapesca",
    "nombreDeQuienResponde": "Carlos Perez",
    "productoQueExporta": "Pescado",
    "enCasoDeQueEligioOtrosMencioneElProductoQueExporta": null,
    "destinoPrincipalDeExportaciones": "Estados Unidos",
    "contactoCorreoElectronico": "cperez@galapesca.com",
    "comoCalificaLaDisponibilidadDeContenedoresRefrigeradosOEstandarSegunSuNecesidad": 3,
    "comoCalificaElEstadoDeEstosContenedoresRefrigeradosOEstandarRespectoDelMesAnterior": 5,
    "queTanFacilFueReservarEspaciosConLasNavierasConLasQueTrabaja": 3,
    "queEstrategiasHaImplementadoParaSolucionarlo": "Diversificación de navieras.",
    "enComparacionAlUltimoTrimestreDel2024T1ComoHanVariadoLosPreciosDeLosServiciosOfrecidosPorLasNavierasDuranteEsteTrimestre": "Ha incrementado",
    "haPodidoPercibirCambiosEnSuRentabilidadDebidoALasVariacionesEnElPrecioDelFlete": "Se han reducido",
    "consideraQueLasTarifasOfrecidasPorLasNavierasSonJustasEnComparacionConElVolumenDeCargaQueManeja": 2,
    "haEnfrentadoCostosAdicionalesInesperadosEnLosUltimosMeses": "Si",
    "enCasoDeQueLaRespuestaAnteriorSeaSiEstosCostosAdicionalesEstanDebidamenteJustificados": "No",
    "consideraQueLosServiciosOfrecidosPorLasNavierasSonCompetitivosEnRelacionConLosDeOtrosPaisesDeLaRegion": "No",
    "haEvaluadoAlternativasDeTransporteDebidoALosCostosActualesDeLasNavieras": "Si",
    "cualesAlternativasDeTransporteHaExplorado": "Aéreo y otros puertos.",
    "queTanTransparenteConsideraQueEsLaEstructuraDeCostosPresentadaPorLasNavieras": 2,
    "enGeneralComoCalificariaLaRelacionCostoBeneficioDeLosServiciosQueRecibeDeLasNavieras": 2,
    "comoCalificaLaClaridadDeLaInformacionProporcionadaPorLasNavierasSobreItinerariosYHorarios": 3,
    "haExperimentadoDificultadesDebidoACambiosDeUltimoMomentoEnLosItinerarios": "Si",
    "enCasoDeSiConQueFrecuenciaHanOcurridoEstosCambios": "Frecuentemente",
    "comoCalificariaLaComunicacionDeLasNavierasAnteEventosImprevistosDemorasODesvios": 2,
    "haTenidoProblemasParaObtenerInformacionActualizadaSobreLaUbicacionDeSusContenedoresDuranteElTransito": "Si",
    "queTanAccesiblesSonLasNavierasCuandoNecesitaResolverDudasOProblemasRelacionadosConLosEnvios": 2,
    "enGeneralComoCalificariaLaCalidadDeLaComunicacionConLasNavierasConLasQueOpera": 2,
    "haRecibidoIncumplimientosDeServiciosPorParteDeAlgunaNaviera": "Si",
    "enCasoDeSiQueTipoDeIncumplimientosHaExperimentado": "Retrasos y cambios de puerto.",
    "haPresentadoQuejasFormalesPorAlgunoDeEstosIncumplimientos": "Si",
    "enCasoDeSiConsideraQueLaRespuestaDeLaNavieraHaSidoAdecuada": "No",
    "consideraQueLasNavierasConLasQueTrabajaCumplenLosCompromisosEstablecidosEnLosContratosDeServicio": 2,
    "queTanFlexibleConsideraQueEsLaNavieraParaNegociarTerminosEnCasosExcepcionalesPorEjemploRetrasosPorFuerzaMayor": 2,
    "enGeneralComoEvaluariaElNivelDeCumplimientoDeLasNavierasConLasQueTrabaja": 2,
    "haEnfrentadoDificultadesEnLosProcesosDeInspeccionYAduanaQueHayanGeneradoRetrasosEnSusOperaciones": "Si",
    "enCasoDeSiQueTipoDeDificultadesHaExperimentado": "Demoras en procesos y documentación.",
    "consideraQueLosProcedimientosAduanerosSonClaramentePredeciblesYOConsistentes": 2,
    "comoCalificariaElManejoDeLaMercanciaDuranteLasInspeccionesAduanerasEnTerminosDeCuidadoYPrevencionDeDanos": 3,
    "haExperimentadoDanosEnSuCargaDebidoAUnaInspeccionInadecuada": "Si",
    "haTenidoProblemasConSusClientesDebidoAlEstadoEnElQueLlegaLaMercanciaDespuesDeLasInspecciones": "Si",
    "consideraQueElPersonalEncargadoDeLasInspeccionesEstaCapacitadoParaManejarSuProductoSinComprometerSuCalidad": 2,
    "cualEsElPrincipalPuertoEnElQueOpera": "Puerto de Guayaquil",
    "comoEvaluaLaCapacidadOperativaDeLosPuertosEnLosQueOpera": 3,
    "haExperimentadoCongestionEnLosPuertosEnLosUltimosMeses": "Si",
    "losAccesosYViasDeComunicacionHaciaLosPuertosFacilitanElTransporteDeSuCarga": 3,
    "consideraQueLaInfraestructuraActualDeLosPuertosEsSuficienteParaLaDemandaExportadoraDeSuSector": "No",
    "responseType": "completed",
    "startDateUtc": "2025-07-29 15:40:12",
    "stageDateUtc": null,
    "submitDateUtc": "2025-07-29 15:45:33",
    "networkId": "ab23cd4590",
    "tags": null,
    "ending": "Thanks for completing this typeform\nNow *create your own* — it's free, easy, & beautiful"
  },
  {
    "id": "inaexpo1234567890abcdef",
    "nombreDeLaEmpresa": "Inaexpo C. A.",
    "nombreDeQuienResponde": "Juan Gomez",
    "productoQueExporta": "Otros",
    "enCasoDeQueEligioOtrosMencioneElProductoQueExporta": "Procesados",
    "destinoPrincipalDeExportaciones": "Estados Unidos",
    "contactoCorreoElectronico": "jgomez@inaexpo.com",
    "comoCalificaLaDisponibilidadDeContenedoresRefrigeradosOEstandarSegunSuNecesidad": 4,
    "comoCalificaElEstadoDeEstosContenedoresRefrigeradosOEstandarRespectoDelMesAnterior": 3,
    "queTanFacilFueReservarEspaciosConLasNavierasConLasQueTrabaja": 4,
    "queEstrategiasHaImplementadoParaSolucionarlo": "Planificación con mayor anticipación.",
    "enComparacionAlUltimoTrimestreDel2024T1ComoHanVariadoLosPreciosDeLosServiciosOfrecidosPorLasNavierasDuranteEsteTrimestre": "Ha incrementado",
    "haPodidoPercibirCambiosEnSuRentabilidadDebidoALasVariacionesEnElPrecioDelFlete": "Se han reducido",
    "consideraQueLasTarifasOfrecidasPorLasNavierasSonJustasEnComparacionConElVolumenDeCargaQueManeja": 3,
    "haEnfrentadoCostosAdicionalesInesperadosEnLosUltimosMeses": "Si",
    "enCasoDeQueLaRespuestaAnteriorSeaSiEstosCostosAdicionalesEstanDebidamenteJustificados": "En algunos casos.",
    "consideraQueLosServiciosOfrecidosPorLasNavierasSonCompetitivosEnRelacionConLosDeOtrosPaisesDeLaRegion": "No",
    "haEvaluadoAlternativasDeTransporteDebidoALosCostosActualesDeLasNavieras": "Si",
    "cualesAlternativasDeTransporteHaExplorado": "Otras rutas y operadores.",
    "queTanTransparenteConsideraQueEsLaEstructuraDeCostosPresentadaPorLasNavieras": 3,
    "enGeneralComoCalificariaLaRelacionCostoBeneficioDeLosServiciosQueRecibeDeLasNavieras": 3,
    "comoCalificaLaClaridadDeLaInformacionProporcionadaPorLasNavierasSobreItinerariosYHorarios": 3,
    "haExperimentadoDificultadesDebidoACambiosDeUltimoMomentoEnLosItinerarios": "Si",
    "enCasoDeSiConQueFrecuenciaHanOcurridoEstosCambios": "Ocasionalmente",
    "comoCalificariaLaComunicacionDeLasNavierasAnteEventosImprevistosDemorasODesvios": 3,
    "haTenidoProblemasParaObtenerInformacionActualizadaSobreLaUbicacionDeSusContenedoresDuranteElTransito": "Si",
    "queTanAccesiblesSonLasNavierasCuandoNecesitaResolverDudasOProblemasRelacionadosConLosEnvios": 3,
    "enGeneralComoCalificariaLaCalidadDeLaComunicacionConLasNavierasConLasQueOpera": 3,
    "haRecibidoIncumplimientosDeServiciosPorParteDeAlgunaNaviera": "Si",
    "enCasoDeSiQueTipoDeIncumplimientosHaExperimentado": "Retrasos puntuales.",
    "haPresentadoQuejasFormalesPorAlgunoDeEstosIncumplimientos": "No",
    "enCasoDeSiConsideraQueLaRespuestaDeLaNavieraHaSidoAdecuada": null,
    "consideraQueLasNavierasConLasQueTrabajaCumplenLosCompromisosEstablecidosEnLosContratosDeServicio": 3,
    "queTanFlexibleConsideraQueEsLaNavieraParaNegociarTerminosEnCasosExcepcionalesPorEjemploRetrasosPorFuerzaMayor": 3,
    "enGeneralComoEvaluariaElNivelDeCumplimientoDeLasNavierasConLasQueTrabaja": 3,
    "haEnfrentadoDificultadesEnLosProcesosDeInspeccionYAduanaQueHayanGeneradoRetrasosEnSusOperaciones": "No",
    "enCasoDeSiQueTipoDeDificultadesHaExperimentado": null,
    "consideraQueLosProcedimientosAduanerosSonClaramentePredeciblesYOConsistentes": 3,
    "comoCalificariaElManejoDeLaMercanciaDuranteLasInspeccionesAduanerasEnTerminosDeCuidadoYPrevencionDeDanos": 3,
    "haExperimentadoDanosEnSuCargaDebidoAUnaInspeccionInadecuada": "No",
    "haTenidoProblemasConSusClientesDebidoAlEstadoEnElQueLlegaLaMercanciaDespuesDeLasInspecciones": "No",
    "consideraQueElPersonalEncargadoDeLasInspeccionesEstaCapacitadoParaManejarSuProductoSinComprometerSuCalidad": 3,
    "cualEsElPrincipalPuertoEnElQueOpera": "Puerto de Guayaquil",
    "comoEvaluaLaCapacidadOperativaDeLosPuertosEnLosQueOpera": 3,
    "haExperimentadoCongestionEnLosPuertosEnLosUltimosMeses": "Si",
    "losAccesosYViasDeComunicacionHaciaLosPuertosFacilitanElTransporteDeSuCarga": 3,
    "consideraQueLaInfraestructuraActualDeLosPuertosEsSuficienteParaLaDemandaExportadoraDeSuSector": "No",
    "responseType": "completed",
    "startDateUtc": "2025-07-29 18:22:10",
    "stageDateUtc": null,
    "submitDateUtc": "2025-07-29 18:28:44",
    "networkId": "cdef987654",
    "tags": null,
    "ending": "Thanks for completing this typeform\nNow *create your own* — it's free, easy, & beautiful"
  },
  {
    "id": "semvraveconsa0987654321abcd",
    "nombreDeLaEmpresa": "Semvra Veconsa S.A.",
    "nombreDeQuienResponde": "Lucia Ramos",
    "productoQueExporta": "Otros",
    "enCasoDeQueEligioOtrosMencioneElProductoQueExporta": "Granos",
    "destinoPrincipalDeExportaciones": "Estados Unidos",
    "contactoCorreoElectronico": "lramos@semvraveconsa.com",
    "comoCalificaLaDisponibilidadDeContenedoresRefrigeradosOEstandarSegunSuNecesidad": 3,
    "comoCalificaElEstadoDeEstosContenedoresRefrigeradosOEstandarRespectoDelMesAnterior": 4,
    "queTanFacilFueReservarEspaciosConLasNavierasConLasQueTrabaja": 4,
    "queEstrategiasHaImplementadoParaSolucionarlo": "Trabajo coordinado con operadores logísticos.",
    "enComparacionAlUltimoTrimestreDel2024T1ComoHanVariadoLosPreciosDeLosServiciosOfrecidosPorLasNavierasDuranteEsteTrimestre": "Ha incrementado",
    "haPodidoPercibirCambiosEnSuRentabilidadDebidoALasVariacionesEnElPrecioDelFlete": "Se han reducido",
    "consideraQueLasTarifasOfrecidasPorLasNavierasSonJustasEnComparacionConElVolumenDeCargaQueManeja": 3,
    "haEnfrentadoCostosAdicionalesInesperadosEnLosUltimosMeses": "Si",
    "enCasoDeQueLaRespuestaAnteriorSeaSiEstosCostosAdicionalesEstanDebidamenteJustificados": "Parcialmente.",
    "consideraQueLosServiciosOfrecidosPorLasNavierasSonCompetitivosEnRelacionConLosDeOtrosPaisesDeLaRegion": "No",
    "haEvaluadoAlternativasDeTransporteDebidoALosCostosActualesDeLasNavieras": "Si",
    "cualesAlternativasDeTransporteHaExplorado": "Rutas alternativas y consolidadores.",
    "queTanTransparenteConsideraQueEsLaEstructuraDeCostosPresentadaPorLasNavieras": 3,
    "enGeneralComoCalificariaLaRelacionCostoBeneficioDeLosServiciosQueRecibeDeLasNavieras": 3,
    "comoCalificaLaClaridadDeLaInformacionProporcionadaPorLasNavierasSobreItinerariosYHorarios": 3,
    "haExperimentadoDificultadesDebidoACambiosDeUltimoMomentoEnLosItinerarios": "Si",
    "enCasoDeSiConQueFrecuenciaHanOcurridoEstosCambios": "Ocasionalmente",
    "comoCalificariaLaComunicacionDeLasNavierasAnteEventosImprevistosDemorasODesvios": 3,
    "haTenidoProblemasParaObtenerInformacionActualizadaSobreLaUbicacionDeSusContenedoresDuranteElTransito": "Si",
    "queTanAccesiblesSonLasNavierasCuandoNecesitaResolverDudasOProblemasRelacionadosConLosEnvios": 3,
    "enGeneralComoCalificariaLaCalidadDeLaComunicacionConLasNavierasConLasQueOpera": 3,
    "haRecibidoIncumplimientosDeServiciosPorParteDeAlgunaNaviera": "Si",
    "enCasoDeSiQueTipoDeIncumplimientosHaExperimentado": "Tiempo de tránsito mayor al esperado.",
    "haPresentadoQuejasFormalesPorAlgunoDeEstosIncumplimientos": "No",
    "enCasoDeSiConsideraQueLaRespuestaDeLaNavieraHaSidoAdecuada": null,
    "consideraQueLasNavierasConLasQueTrabajaCumplenLosCompromisosEstablecidosEnLosContratosDeServicio": 3,
    "queTanFlexibleConsideraQueEsLaNavieraParaNegociarTerminosEnCasosExcepcionalesPorEjemploRetrasosPorFuerzaMayor": 3,
    "enGeneralComoEvaluariaElNivelDeCumplimientoDeLasNavierasConLasQueTrabaja": 3,
    "haEnfrentadoDificultadesEnLosProcesosDeInspeccionYAduanaQueHayanGeneradoRetrasosEnSusOperaciones": "Si",
    "enCasoDeSiQueTipoDeDificultadesHaExperimentado": "Demoras y revisiones adicionales.",
    "consideraQueLosProcedimientosAduanerosSonClaramentePredeciblesYOConsistentes": 3,
    "comoCalificariaElManejoDeLaMercanciaDuranteLasInspeccionesAduanerasEnTerminosDeCuidadoYPrevencionDeDanos": 3,
    "haExperimentadoDanosEnSuCargaDebidoAUnaInspeccionInadecuada": "No",
    "haTenidoProblemasConSusClientesDebidoAlEstadoEnElQueLlegaLaMercanciaDespuesDeLasInspecciones": "No",
    "consideraQueElPersonalEncargadoDeLasInspeccionesEstaCapacitadoParaManejarSuProductoSinComprometerSuCalidad": 3,
    "cualEsElPrincipalPuertoEnElQueOpera": "Puerto de Guayaquil",
    "comoEvaluaLaCapacidadOperativaDeLosPuertosEnLosQueOpera": 3,
    "haExperimentadoCongestionEnLosPuertosEnLosUltimosMeses": "Si",
    "losAccesosYViasDeComunicacionHaciaLosPuertosFacilitanElTransporteDeSuCarga": 3,
    "consideraQueLaInfraestructuraActualDeLosPuertosEsSuficienteParaLaDemandaExportadoraDeSuSector": "No",
    "responseType": "completed",
    "startDateUtc": "2025-07-30 09:02:45",
    "stageDateUtc": null,
    "submitDateUtc": "2025-07-30 09:09:18",
    "networkId": "f0e1d2c3b4",
    "tags": null,
    "ending": "Thanks for completing this typeform\nNow *create your own* — it's free, easy, & beautiful"
  }
];
